<template>
  <footer class="site-footer">
    <div class="site-footer__container">
      <div class="site-footer__left">
        <a
          class="site-footer__link site-footer__media"
          target="_blank" href="https://www.instagram.com/standardmodelmanagement/"
        >
          instagram
        </a>
        <a
          class="site-footer__link site-footer__media"
          target="_blank"
          href="https://www.facebook.com/standardmgmt/"
        >
          facebook
        </a>
      </div>
      <div class="site-footer__right">
        <a class="site-footer__link" href="mailto:anastasia@standard-mgmt.com" >for booking inquiries : anastasia@standard-mgmt.com</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.site-footer {
  @include fonts.mo-semi;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 45px;
  height: 50px;
  font-size: 10px;
  line-height: 21px;
  background-color: colors.$grayef;

  &__container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1064px;
  }

  &__media {
    transition: 200ms all ease;
    &:hover {
      color: colors.$gray99;
    }
    &:not(:first-of-type) {
      margin-left: 10px;
    }
  }

  &__link {
    text-decoration: none;
    text-transform: uppercase;
    transition: 200ms all ease;
    color: #000;
    &:hover {
      color: colors.$gray99;
    }
  }
}

@media screen and (max-width: 767px) {
  .site-footer {
    height: auto;
    padding: 0 12px 10px;
    background-color: #fff;
    &__right {
      display: none;
    }
  }
}
</style>